export enum StatusCode {
  SUCCESS = 200,
  UNAUTHORIZED = 401,
  BLOCK = 403,
  INVALID = 400,
  NOTFOUND = 404,
  SYSTEMERROR = 500
}
